import React from 'react';
import PropTypes from 'prop-types';
import ServiceCallout from './components/ServiceCallout';


const ComponentsMap = {
  service: ServiceCallout,
};

const AddOnCallout = (props) => {
  const { addOn: { type } } = props;

  const Component = ComponentsMap[type];

  return Component ? <Component {...props} /> : null;
};

AddOnCallout.propTypes = {
  addOn: PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(ComponentsMap)).isRequired,
  }).isRequired,
};

export default AddOnCallout;
